import { gatewayInstance } from "../server/gateway";
import { FocusSDK, getAppId } from "@/utils";
import { SearchGlobalParams, SearchType } from "@jd/focus-desktop-comps/lib/es/UserSelection";
import ImService from "@/server/ImService";
import PinyinMatch from "pinyin-match";
import cookies from "js-cookie";
import { getDeptPositionDesc } from "@/models/user";
import { changeEgovUrl } from "@/utils/tools";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import { message } from "antd";
import i18n from "@/i18n";
import { setUserTypeChange } from "@/components/Tags";
import { getHighlightComp } from "@/utils/search";

// export enum SearchType {
//     All = '0',
//     Contacts = '1',
//     Group = '2',
//     App = '3',
//     JoySpace = '4',
//     MessageHistory = '-1',
// }

// export interface SearchGlobalParams {
//     keyword: string;
//     searchType?: SearchType;
//     pageNo?: number;
//     pageSize?: number;
// }

export async function searchExternalContacts({
  keyword,
  searchType = SearchType.Contacts,
  pageNo = 1,
  pageSize = 20
}: SearchGlobalParams): Promise<any> {
  const imService = ImService.getInstance();
  const externalContacts = await imService.getExternalContacts();
  const currentEmployee = await imService.getCurrentEmployee();
  return externalContacts?.reduce((result, item) => {
    const employee = item.employee;
    if (!employee) {
      // eslint-disable-next-line no-console
      console.log("getExternalContacts exception item =>", JSON.stringify(item));
    }
    const matched = PinyinMatch.match(employee.name || "", keyword);
    const employeeExt = employee?.employeeExt || {};
    const userType = setUserTypeChange(
      { ...employee, userType: employeeExt?.userType },
      currentEmployee
    );
    if (matched) {
      result.push({
        app: item.app,
        deptName: item.employee?.station,
        avatar: changeEgovUrl(item.employee?.avatar),
        userId: item.userId,
        realName: item.employee?.name || item.employee?.nickName,
        teamId: item.teamId,
        highlight: [
          {
            name: "realName",
            value: item.employee?.name || item.employee?.nickName,
            key: Array.isArray(matched)
              ? item.employee?.name.slice(matched[0], matched[1] + 1)
              : keyword
          }
        ],
        desc: getDeptPositionDesc({
          deptName: item.employee?.e_dept_full_name || item.employee?.deptName || "",
          titleName: item.employee?.e_position || item.employee?.titleName || "",
          unitName: item.employee?.unitName || "",
          userType
        })
      });
    }
    return result;
  }, [] as any);
}

export async function getSearchGlobal(params: SearchGlobalParams, current?: any): Promise<any> {
  try {
    const searchGlobalList = await searchGlobal(params);
    let currentEmployee = {};
    if (current) {
      currentEmployee = current;
    } else {
      const imService = ImService.getInstance();
      currentEmployee = await imService.getCurrentEmployee();
    }

    return {
      contacts: searchGlobalList?.contacts
        ? searchGlobalList?.contacts.map((item: any) => {
            const userType = setUserTypeChange(item, currentEmployee);
            return {
              ...item,
              desc: getDeptPositionDesc({
                unitName: item.unitName || "",
                deptName: item?.deptName || "",
                titleName: item?.titleName || "",
                userType
              }),
              userType
            };
          })
        : [],
      groups: searchGlobalList?.groups
        ? searchGlobalList?.groups.map((item: any) => {
            return {
              ...item,
              // kind === 512  && sub_kind  === 5; 内部群 1
              // kind === 1024 && sub_kind 6;外部群（群包含：同租户外部联系人或者跨租户人员）2
              // kind === 10241024 && sub_kind 3；跨平台群 3
              groupType: item.kind === 512 ? 1 : item.kind === 1024 && item.subKind === 6 ? 2 : 3
            };
          })
        : [],
      depts: searchGlobalList?.depts
        ? searchGlobalList?.depts
        : { data: [], message: "", code: "" },
      hasMoreDepts: searchGlobalList.hasMoreDepts,
      hasMoreContacts: searchGlobalList.hasMoreContacts,
      hasMoreGroups: searchGlobalList.hasMoreGroups
    };
  } catch (error) {
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl(),
      checkType: UseCheckType.API
    });
    const onLine = await netServer.checkNet();
    if (onLine) {
      return error.message;
    } else {
      const str = i18n.t("Network Error");
      message.error(str);
      return str;
    }
  }
}

export async function getSearchStranger(params: { keyword: string }, current?: any): Promise<any> {
  try {
    const searchGlobalList = await searchStranger(params);
    let currentEmployee = {};
    if (current) {
      currentEmployee = current;
    } else {
      const imService = ImService.getInstance();
      currentEmployee = await imService.getCurrentEmployee();
    }

    return {
      ...searchGlobalList,
      contactList: searchGlobalList?.contactList
        ? searchGlobalList?.contactList.map((item: any) => {
            const userType = setUserTypeChange(item, currentEmployee);
            return {
              ...item,
              desc: getDeptPositionDesc({
                unitName: item.unitName || "",
                deptName: item?.deptName || "",
                titleName: item?.titleName || "",
                userType
              }),
              userType
            };
          })
        : []
    };
  } catch (error) {}
}
/**
 * 添加联系人
 *
 * @export
 * @param {*} opts
 * @returns
 */
export async function searchContact({
  keyword,
  pageNo = 1,
  pageSize = 10
}: {
  keyword: string;
  pageNo: number;
  pageSize: number;
}): Promise<any> {
  return gatewayInstance.request({
    api: "search.searchTeamConcatByKeyword",
    method: "POST",
    body: {
      appKey: FocusSDK.authInfo?.ddAppId || cookies.get("focus-app-id") || (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "gwork",
      indexName: "global",
      keyword,
      pageNo,
      pageSize
    }
  });
}

/**
 * 添加联系人
 *
 * @export
 * @param {*} opts
 * @returns
 */
export async function searchRobot({
  keyword,
  pageNo = 1,
  pageSize = 10
}: {
  keyword: string;
  pageNo: number;
  pageSize: number;
}): Promise<any> {
  return gatewayInstance.request({
    api: "search.searchBotByKeyword",
    method: "POST",
    body: {
      appKey: FocusSDK.authInfo?.ddAppId || cookies.get("focus-app-id") || (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "gwork",
      indexName: "global",
      keyword,
      pageNo,
      pageSize
    }
  });
}

/**
 * 搜索用户
 *
 * @export
 * @param {*} opts
 * @returns
 */
export async function searchGlobal({
  keyword,
  searchType = SearchType.All,
  pageNo = 1,
  pageSize = 10
}: SearchGlobalParams): Promise<any> {
  return gatewayInstance.request({
    api: "search.searchGlobal",
    method: "POST",
    body: {
      appId: getAppId(), // isFocus ? process.env.REACT_APP_DESKTOP_APPID : process.env.REACT_APP_WEB_APPID,
      appKey: FocusSDK.authInfo?.ddAppId || cookies.get("focus-app-id") || (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "gwork",
      indexName: "global",
      keyword,
      searchType,
      pageNo,
      pageSize
    }
  });
}

/**
 * 搜索非联系人
 *
 * @export
 * @param {*} opts
 * @returns
 */
export async function searchStranger({ keyword }: { keyword: string }): Promise<any> {
  return gatewayInstance.request({
    api: "search.searchStranger",
    method: "POST",
    body: {
      keyword
    }
  });
}

export async function searchContactByTelephone(telephone: string) {
  return gatewayInstance.request({
    api: "search.searchConcatByKeyword",
    method: "POST",
    body: {
      appId: getAppId(), // isFocus ? process.env.REACT_APP_DESKTOP_APPID : process.env.REACT_APP_WEB_APPID,
      appKey: FocusSDK.authInfo?.ddAppId || cookies.get("focus-app-id") || (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "gwork",
      keyword: telephone,
      indexName: "account_t_empl"
    }
  });
}

export async function searchGroupByGroupNo(groupNo: string) {
  return gatewayInstance.request({
    api: "search.searchGroupByGroupId",
    method: "POST",
    body: {
      appId: getAppId(), // isFocus ? process.env.REACT_APP_DESKTOP_APPID : process.env.REACT_APP_WEB_APPID,
      appKey: FocusSDK.authInfo?.ddAppId || cookies.get("focus-app-id") || (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "gwork",
      groupId: groupNo,
      indexName: "timline_t_group"
    }
  });
}

export async function cascadeSearchDept(body: any = {}) {
  return gatewayInstance
    .request({
      api: "ebook.cascadeSearchDept",
      method: "POST",
      body
    })
    .then((res) => res)
    .catch((err) => {
      message.error(err.message);
    });
}

export async function reportSearchRecord(opts: {
  keyword: string; // 搜索关键字<1800
  searchUuid: string; // uuid
  searchHit: string; // 大搜返回被点击的那个结构即可
  searchType: string; // contact|app|dept|group|work|page|schedule
}) {
  return gatewayInstance.request({
    api: "search.reportSearchRecord",
    method: "POST",
    body: opts
  });
}
